"use client";

import { FC } from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { GA4 } from "@/utils/ga4Utils";
import { cn } from "@/utils/general";
import { ThemeTypes } from "@/utils/theming";

import styles from "./SiteSwitch.module.scss";

interface SiteSwitchProps {
  className?: string;
  theme?: ThemeTypes;
}

const SiteSwitch: FC<SiteSwitchProps> = ({ className = "", theme = "master" }) => {
  const onRedirect = (destination: string, text: string) => {
    GA4.onNavigationClicked({
      destination,
      text,
    });
  };

  return (
    <div className={cn("hidden lg:block", className)}>
      <div className={styles.switchWrap}>
        {theme !== "men" ? (
          <>
            <div className={styles.switchBox}>
              <TextElementNova text="Women" className="CTA-10-Dia-Normal text-nova-base-black" />
            </div>
            <div className={styles.switchBox}>
              <LinkHandler
                path={`/men/`}
                onClick={() => {
                  onRedirect("/men/", "Men");
                }}
                className={styles.switchLink}
              >
                <TextElementNova
                  text="Men"
                  className="CTA-10-Dia-Normal text-nova-transparency-black-70"
                />
              </LinkHandler>
            </div>
          </>
        ) : (
          <>
            <div className={styles.switchBoxMen}>
              <LinkHandler
                path={`/`}
                onClick={() => {
                  onRedirect("/", "Women");
                }}
                className={styles.switchLink}
              >
                <TextElementNova
                  text="Women"
                  className="CTA-10-Dia-Normal text-nova-transparency-black-70"
                />
              </LinkHandler>
            </div>
            <div className={cn(styles.switchBoxMen)}>
              <TextElementNova
                text="Men"
                className="CTA-10-Dia-Normal text-nova-transparency-black-70 acitvetab"
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SiteSwitch;
